<template>
  <el-card>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.label" :name="item.value">
        <el-button v-if="item.value ==='second'" v-permisaction="['config:apply_log:handler']" size="mini" type="primary" style="margin-bottom: 5px;" @click="handleAll">审批全部</el-button>
        <template #label>
          <div v-if="item.value ==='second'">

            <el-badge :value="tabCount" class="item">
              {{ item.label }}
            </el-badge>

          </div>
          <div v-else>
            {{ item.label }}
          </div>
        </template>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="编号"
            width="180"
            align="center"
          />
          <el-table-column
            prop="title"
            label="模块"
            align="center"
          />

          <el-table-column
            prop="apply_nick_name"
            label="申请人"
            align="center"
          />
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            :formatter="statusFormatter"
          />
          <el-table-column
            prop="created_at"
            label="申请时间"
            align="center"
          />
          <el-table-column
            prop="upadted_at"
            label="审批时间"
            align="center"
          >
            <template scope="scope">
              <span v-if="scope.row.status > 0">{{ scope.row.upadted_at }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="approver_mark"
            label="审批备注"
            align="center"
          />
          <el-table-column
            prop="approver_nick_name"
            label="操作人"
            align="center"
          >
            <template scope="scope">
              <div v-if="scope.row.status===0">
                <el-button v-permisaction="['config:apply_log:handler']" size="mini" type="success" @click="edit(scope.row.id,1,scope.row.path)">通过</el-button>
                <el-button v-permisaction="['config:apply_log:handler']" size="mini" type="danger" @click="edit(scope.row.id,2,scope.row.path)">拒绝</el-button>
              </div>
              <div v-else>{{ scope.row.approver_nick_name }}</div>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="35%"
    >
      <el-form>
        <el-form-item>
          <el-input v-model="form.mark" placeholder="审批备注" :rows="4" type="textarea" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getCacheClearList, updateCacheClearCfg } from '@/api/config/clear-cache-cfg'

export default {
  name: 'ApplyLOg',
  data() {
    return {
      dialogVisible: false,
      total: 0,
      tabCount: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        status: 1
      },
      form: {
        id: 0,
        mark: '',
        data: '',
        url: ''
      },
      tableData: [],
      activeName: 'first',
      tab: [{ label: '审批列表', value: 'first' }, { label: '待审批', value: 'second' }]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClick(tab, event) {
      this.queryParams.status = parseInt(tab.index) + 1
      this.getTables()
    },
    handleAll() {
      this.form.data = 'all'
      this.dialogVisible = true
      this.form.status = 1
    },
    getTables() {
      getCacheClearList(this.queryParams).then(res => {
        this.tableData = res.data.list.list
        this.tabCount = res.data.list.count
        this.total = res.data.count
      })
    },
    edit(id, status, path) {
      this.dialogVisible = true
      this.form.id = id
      this.form.url = path
      this.form.status = status
    },
    onSubmit() {
      this.dialogVisible = false
      updateCacheClearCfg(this.form).then(res => {
        this.form.data = ''
        this.msgSuccess('审核成功')
        this.getTables()
      })
    },
    statusFormatter(row) {
      const statusArr = ['未审核', '已审核', '已拒绝']
      switch (row.status) {
        case 0:
          return <span style='color:#E6A23C'>{statusArr[row.status]}</span>
        case 1:
          return <span style='color:#67C23A'>{statusArr[row.status]}</span>
        case 2:
          return <span style='color:#F56C6C'>{statusArr[row.status]}</span>
      }
    }
  }
}
</script>

<style scoped>
.item{
  margin-top: 5px;
  margin-right: 40px;
}
</style>
